import gql from "graphql-tag";

export default {
  mutation: gql`
    mutation editProcessingUser($username: String) {
      createProcessingUser(username: $username) {
        success
      }
    }
  `,
  mutationName: "editProcessingUser",
};



// WEBPACK FOOTER //
// ./src/model/gql/mutations/users/processingUser/editProcessingUser.js